const statuses = {
  BLOCKED: 'BLOCKED',
  UNBLOCKED: 'UNBLOCKED',
};

export default statuses;
